import { render, staticRenderFns } from "./PlanCard.vue?vue&type=template&id=6b1df4aa&scoped=true"
import script from "./PlanCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PlanCard.vue?vue&type=style&index=0&id=6b1df4aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1df4aa",
  null
  
)

export default component.exports